import { connect } from "react-redux";
import Recipe from "./Recipe";
import RecipeForm from "./RecipeForm";
import { getRecipes } from "../Actions/recipeActions";
import { Component } from "react";
import {
	Button,
	FormControl,
	InputAdornment,
	TextField,
} from "@material-ui/core";
import Typography from "@mui/material/Typography";
import { Search } from "@material-ui/icons";
import { axiosWithAuth } from "../Helpers/AxiosWithAuth";

import SingleRecipe from "./SingleRecipe";

export class RecipeBook extends Component {
	constructor(props) {
		super(props);
		this.state = {
			recipes: [],
			loading: false,
			user: props.user,
			// search: "Search for Recipes",
			found: {},
			finishSearch: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		this.props.getRecipes();
		this.setState({ ...this.state, loading: this.props.recipes.loading });
	}

	componentDidUpdate(prevProps) {
		if (prevProps.recipes !== this.props.recipes) {
			this.setState({
				...this.state,
				recipes: this.props.recipes.recipes,
				loading: false,
			});
		}
	}

	handleChange(event) {
		this.setState({ search: event.target.value });
	}
	handleSubmit(e) {
		e.preventDefault();
		console.log(this.state.search);
		const foundRecipe = this.state.recipes.filter(
			(recipe) => recipe.recipe_title === this.state.search
		);
		console.log("foundRecipe", foundRecipe);
		this.setState({ found: foundRecipe });
		console.log("foundRecipe.recipe_id", foundRecipe[0].recipe_id);
		axiosWithAuth()
			.get(`api/recipes/${foundRecipe[0].recipe_id}`)
			.then((res) => {
				console.log(res.data);
				this.setState({ finishSearch: true });
			})

			.catch((err) => console.log(err));
	}

	render() {
		if (this.state.finishSearch === true) {
			return <SingleRecipe props={this.state.found[0]} />;
		}

		if (this.state.loading || this.state.recipes.length === 0) {
			return <div>Loading</div>;
		} else {
			return (
				<div className="recipebook-container"><br />
					<Typography variant="h4" component="h2">
						{this.state.user.loggedUser.username
							? this.state.user.loggedUser.username
							: "Nobody"}
						's Secret Recipe Book
					</Typography>
					<FormControl>
						<TextField
							id="input-with-icon-textfield"
							type="text"
							name="search"
							label="Search for Recipes"
							// placeholder="Search for Recipes"
							value={this.state.search}
							onChange={this.handleChange}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<Button
											onClick={this.handleSubmit}
											variant="contained"
											color="primary"
										>
											<Search />
										</Button>
									</InputAdornment>
								),
							}}
							variant="standard"
						/>
					</FormControl>

					<RecipeForm props={this.state.user.loggedUser.user_id} />

					<div>
						{this.state.recipes === [] ? (
							<p className="center"> Add some recipes!</p>
						) : (
							this.state.recipes.map((recipe) => (
								<Recipe key={recipe.id} props={recipe} />
							))
						)}
					</div>
					
					{/* Moved RecipeForm component to the top of the Recipe Book to see if it works visually */}	

					{/* <RecipeForm props={this.state.user.loggedUser.user_id} /> */}
				</div>
			);
		}
	}
}

const mapStateToProps = (state) => ({
	recipes: state.recipeReducer,
	user: state.userReducer,
});

const mapDispatchToProps = (dispatch) => {
	return {
		getRecipes: () => dispatch(getRecipes()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipeBook);
